export const SET_M2_CUSTOMER_SEGMENTS_SUCCESS = 'SET_M2_CUSTOMER_SEGMENTS_SUCCESS';
export const SET_M2_REQUEST = 'SET_M2_REQUEST';
export const SET_M2_FAILED = 'SET_M2_FAILED';
export const CLEAN_M2 = 'CLEAN_M2';
